import { useState, useEffect, useCallback, useRef } from "react";

import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { Dropdown, Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { getTripsListApi, deleteTripsApi, updateDriverAPI, getNextMilestoneApi, getUpdateMilestoneApi, getProductDetailsApi, productConfirmationApi, paymentUpdateApi, paymentUpdateImageApi, addTripHistoryAttachmentsApi, downloadTripTemplateApi, downloadBase64File } from "./trips-api";
import { useGlobal } from "../../GlobalContext";
import profileIcon from "../../assets/png/profile-ic.png";
import emailIcon from "../../assets/svg/email_ic.svg";
import phoneIcon from "../../assets/svg/phone_ic.svg";
import editIcon from "../../assets/svg/edit_ic.svg";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";
import Loader from "../common/loader";
import LoaderModal from "../common/loader";
import deleteIcon from "../../assets/svg/delete_ic.svg";
import moreIcon from "../../assets/svg/more_ic.svg";
import tripIcon from "../../assets/svg/trip-list.svg";
import tripIdIcon from "../../assets/svg/trip-id.svg";
import timeIcon from "../../assets/svg/time_ic.svg";
import truckIcon from "../../assets/svg/truck_ic.svg";
import addressIcon from "../../assets/svg/address_ic.svg";
import Sidebar from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import DriverAllocationModal from "./DriverAllocationModal";
import MilestoneUpdateModal from "./MilestoneUpdateModal";
import DeliveredModal from "./DeliveredModal";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import { downloadStopsExcelTemplate } from "../stops/stops-api";
import StopsExcelUploadModal from "../stops/StopsExcelUploadModal";
import PaymentModal from "./PaymentModal";

export const TripsListing = () => {
  const { rolePermissionList, userType } = useGlobal();
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  function checkPermission(permission) {
    return rolePermissionList.findIndex((element) => element["name"] === "Trips" && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;

  // variable initial
  const isFirstRender = useRef(true);
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });

  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [productSelect, setProductSelect] = useState(null);
  const [vendorSelect, setVendorSelect] = useState(null);

  const [active, setActive] = useState("grid");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stageOption, setStageOption] = useState([
    { value: "", label: "All" },
    { value: "Delivered", label: "Delivered" },
    { value: "Partially delivered", label: "Partially delivered" },
    { value: "Completed", label: "Completed" },
  ]);
  const [stageListOption, setListStageOption] = useState([]);
  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ]);
  const [tripsList, setTripsList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showDriverAllocationModal, setShowDriverAllocationModal] = useState(false);
  const [allocationTripId, setAllocationTripId] = useState(null);
  // handle
  const handleSelectProduct = (option) => {
    console.log("Selected option:", option);
    setProductSelect(option);
  };

  const [customerSelect, setCustomerSelect] = useState(null);
  const [locationSelect, setLocationSelect] = useState(null);
  const [statusSelect, setStatusSelect] = useState(null);
  const handleSelectCustomer = (option) => {
    console.log("Selected option:", option);
    setCustomerSelect(option);
  };
  const handleClearCustomer = () => {
    setCustomerSelect(null);
  };

  const handleSelectLocation = (option) => {
    setLocationSelect(option);
  };
  const handleClearLocation = () => {
    setLocationSelect(null);
  };

  const handleSelectStatus = (option) => {
    console.log("Selected option:", option);
    setStatusSelect(option);
  };

  const handleClearStatus = () => {
    setStatusSelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const handleDownloadTemplate = async () => {
    setIsLoading(true);
    try {
      const res = await downloadTripTemplateApi();

      if (res.data.success && res.data.base64) {
        let filename = "trip_template.xlsx";
        if (res.data.url) {
          const urlParts = res.data.url.split("/");
          const filenamePart = urlParts[urlParts.length - 1].split("?")[0];
          if (filenamePart) {
            filename = filenamePart;
          }
        } else if (res.data.filename) {
          filename = res.data.filename;
        }

        downloadBase64File(res.data.base64, filename);

        setSnackbarMessage("Template downloaded successfully");
        setSnackbarStatus(true);
        handleSnackbarShow();
      } else {
        setSnackbarMessage(res.data.message || "Failed to download template");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error downloading template:", err);
      setSnackbarMessage("Error downloading template");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };
  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const handleDateChange = ({ start, end }) => {
    setStartDate(start);
    setEndDate(end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };
  // useEffect

  useEffect(() => {
    getTripsList();
  }, [itemsPerPage, itemOffset, search, selectedSortby, statusSelect, customerSelect, locationSelect, startDateSave, endDateSave]);

  // Api

  const getTripsList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || ["Created", "desc"];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      status: statusSelect?.value ?? "",
      customer_id: customerSelect?.value ?? "",
      location_id: locationSelect?.value ?? "",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getTripsListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setTripsList(response.data.trips ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  const deleteVendor = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteTripsApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getTripsList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const handleDriverAllocate = async (payload) => {
    try {
      const response = await updateDriverAPI(payload);
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = { vehicle_id: "", users: "" };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgAllocation(validationTemp);
        });
      } else if (response.data.success === true) {
        setShowDriverAllocationModal(false);
        setSnackbarMessage("Driver assigned successfully");
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = { vehicle_id: "", users: "" };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgAllocation(validationTemp);
        });
      }
      console.log("Allocating driver payload:", payload);
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }

    // Refresh list or take action as needed
    // getTripsList();
  };

  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [milestoneDetails, setMilestoneDetails] = useState({});

  const getMilestoneDetails = async (id) => {
    try {
      const response = await getNextMilestoneApi(id);
      if (response.data.success === true) {
        setMilestoneDetails(response.data);
        setShowMilestoneModal(true);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }

    // Refresh list or take action as needed
    // getTripsList();
  };
  const [errorMsgMilestone, setErrorMsgMilestone] = useState({
    status: "",
    comments: "",
    signature: "",
    attachments: "",
    latitude: "",
    longitude: "",
  });
  const [errorMsgAllocation, setErrorMsgAllocation] = useState({
    vehicle_id: "",
    users: "",
  });

  const [errorMsgPaymentUpdate, setErrorMsgPaymentUpdate] = useState({
    payment_method: "",
    amount: "",
    signature: "",
    attachments: "",
  });

  const handleMilestoneUpdate = async (payload) => {
    try {
      const response = await getUpdateMilestoneApi(payload);
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            status: "",
            comments: "",
            signature: "",
            attachments: "",
            latitude: "",
            longitude: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgMilestone(validationTemp);
        });
      } else if (response.data.success === true) {
        const tripHistoryId = response.data.trip_history_id;
        // Store context BEFORE clearing milestoneDetails
        if (response.data.redirectPage === "production-confirmation") {
          const context = {
            stop_id: payload.stop_id,
            trip_id: milestoneDetails?.trip?.id ?? 0,
            milestone_id: milestoneDetails?.status && Array.isArray(milestoneDetails.status) && milestoneDetails.status.length > 0 ? milestoneDetails.status[0].milestone_id : 0,
          };
          console.log("Storing delivery context:", context);
          setDeliveryContext(context);
        }
        if (payload.attachments && payload.attachments.length > 0 && tripHistoryId) {
          try {
            const attachmentPayload = { attachments: payload.attachments };
            await addTripHistoryAttachmentsApi(tripHistoryId, attachmentPayload);
          } catch (attachErr) {
            console.error("Error uploading attachments:", attachErr);
          }
        }

        setShowMilestoneModal(false);
        if (response.data.redirectPage === "") {
          getTripsList();
          setMilestoneDetails({});
        } else if (response.data.redirectPage === "production-confirmation") {
          getProductDetails(payload.stop_id);
        }
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = {
            status: "",
            comments: "",
            signature: "",
            attachments: "",
            latitude: "",
            longitude: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgMilestone(validationTemp);
        });
      }
      return response;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const [showDeliveredModal, setShowDeliveredModal] = useState(false);
  const [stopProduct, setStopProduct] = useState([]);
  const [deliveryContext, setDeliveryContext] = useState({
    stop_id: 0,
    trip_id: 0,
    milestone_id: 0,
  });
  const getProductDetails = async (stopId) => {
    try {
      const response = await getProductDetailsApi(stopId);
      if (response.data.success === true) {
        setStopProduct(
          response.data.products?.map((product) => ({
            ...product,
            duplicateprice: product.price,
            singleprice: (parseFloat(product.price) || 0) / (parseInt(product.quantity) || 1),
            returnqty: 0,
            dueqty: 0,
          }))
        );
        setShowDeliveredModal(true);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }

    // Refresh list or take action as needed
    // getTripsList();
  };

  const handleDeliveryUpdate = async (payload) => {
    console.log("trips-list handleDeliveryUpdate called");
    console.log("deliveryContext:", deliveryContext);
    console.log("Received payload:", payload);

    try {
      // Use stored context instead of milestoneDetails
      payload.stop_id = deliveryContext.stop_id;
      payload.trip_id = deliveryContext.trip_id;
      payload.milestone_id = deliveryContext.milestone_id;

      // Validate required IDs
      if (payload.stop_id === 0 || payload.trip_id === 0 || payload.milestone_id === 0) {
        console.error("Missing required IDs in payload:", {
          stop_id: payload.stop_id,
          trip_id: payload.trip_id,
          milestone_id: payload.milestone_id,
        });
        setSnackbarMessage("Error: Missing required information. Please update the milestone first.");
        setSnackbarStatus(false);
        handleSnackbarShow();
        return;
      }

      const response = await productConfirmationApi(payload);
      console.log("Product confirmation response:", response);

      if (response.data.success === true) {
        if (response.data.redirectPage === "") {
          setShowDeliveredModal(false);
          getTripsList();
        } else if (response.data.redirectPage === "payment") {
          setShowDeliveredModal(false);
          setShowPaymentModal(true);
        }
      } else {
        console.error("API returned success=false:", response.data);
        setSnackbarMessage(response.data.message || "Failed to update delivery information");
        setSnackbarStatus(false);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error in handleDeliveryUpdate:", err);
      setSnackbarMessage("An error occurred while updating delivery information");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };

  const handlePaymentUpdate = async (payload) => {
    console.log("trips-list handlePaymentUpdate called");
    console.log("deliveryContext:", deliveryContext);
    console.log("Received payload:", payload);

    try {
      // Use stored context instead of milestoneDetails
      payload.stop_id = deliveryContext.stop_id;
      payload.trip_id = deliveryContext.trip_id;
      payload.milestone_id = deliveryContext.milestone_id;

      console.log("Final payment payload with IDs:", payload);

      // Validate required IDs
      if (payload.stop_id === 0 || payload.trip_id === 0 || payload.milestone_id === 0) {
        console.error("Missing required IDs in payment payload:", {
          stop_id: payload.stop_id,
          trip_id: payload.trip_id,
          milestone_id: payload.milestone_id,
        });
        setSnackbarMessage("Error: Missing required information for payment.");
        setSnackbarStatus(false);
        handleSnackbarShow();
        return;
      }

      const response = await paymentUpdateApi(payload);
      console.log("Payment update response:", response);

      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const validationTemp = {
            payment_method: "",
            amount: "",
            signature: "",
            attachments: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgPaymentUpdate(validationTemp);
        });
      } else if (response.data.success === true) {
        setShowPaymentModal(false);
        getTripsList();
        setSnackbarMessage("Payment updated successfully");
        setSnackbarStatus(true);
        handleSnackbarShow();
      } else {
        new Promise((resolve, reject) => {
          const validationTemp = {
            payment_method: "",
            amount: "",
            signature: "",
            attachments: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          setErrorMsgPaymentUpdate(validationTemp);
        });
      }
    } catch (err) {
      console.error("Error in handlePaymentUpdate:", err);
      setSnackbarMessage("An error occurred while updating payment");
      setSnackbarStatus(false);
      handleSnackbarShow();
    } finally {
      setIsLoading(false);
    }
  };

  const [showPaymentModal, setShowPaymentModal] = useState(false);

  return (
    <>
      <LoaderModal show={isLoading} />
      <StopsExcelUploadModal
        show={showExcelUploadModal}
        type={"Trip"}
        onHide={() => setShowExcelUploadModal(false)}
        onUploadSuccess={() => {
          getTripsList();
          setSnackbarMessage("Trip imported successfully");
          setSnackbarStatus(true);
          handleSnackbarShow();
        }}
      />
      <DriverAllocationModal show={showDriverAllocationModal} onHide={() => setShowDriverAllocationModal(false)} tripId={allocationTripId} apiUrl={apiUrl} onSubmit={handleDriverAllocate} errorMsgAllocation={errorMsgAllocation} />
      <MilestoneUpdateModal
        show={showMilestoneModal}
        onHide={() => {
          setShowMilestoneModal(false);
          setMilestoneDetails({});
        }}
        onSubmit={handleMilestoneUpdate}
        milestoneDetails={milestoneDetails}
        errorMsgMilestone={errorMsgMilestone}
      />
      <DeliveredModal
        show={showDeliveredModal}
        onHide={() => {
          setShowDeliveredModal(false);
        }}
        onSubmit={handleDeliveryUpdate}
        products={stopProduct}
      />
      <PaymentModal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} onSubmit={handlePaymentUpdate} errorMsgPaymentUpdate={errorMsgPaymentUpdate} />
      <DeleteModal
        title={"trip"}
        isOpen={isOpenDelete}
        onClose={() => {
          setIsOpenDelete(false); // close modal
          setDeleteId(null); // reset selected ID
        }}
        onDelete={deleteVendor}
      />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Trips" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  " style={{ width: "calc(100vw - 80px)" }}>
          <Navbar pageTitle="Trips" />
          {/*  <Navbar pageTitle="Receipt" /> */}
          <div className="bg-half-white p-2 scroll-hidden" style={{ height: "calc(100vh - 56px)" }}>
            <div className=" p-4">
              {" "}
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* Left: Heading */}
                <div className="my-heading fs-24 fw-600" style={{ color: "#9299A7" }}>
                  Trips : {totalCount}
                </div>

                {/* Right: Controls */}
                <div className="d-flex flex-wrap gap-3">
                  {/* Search */}
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor" value={search || ""} onChange={(e) => setSearch(e.target.value)} />
                  </div>

                  {/* Add New Vendor */}

                  {checkPermission("create_permission") && (
                    <div
                      className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => navigate("/trips/create")}
                      style={{
                        height: "40px", // Adjust button height if needed
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} /> {/* ✅ Smaller Icon */}
                      </div>

                      <div
                        className="fs-12 fw-600" // ✅ Reduced text size
                        style={{ lineHeight: "16px" }}
                      >
                        New Trip
                      </div>
                    </div>
                  )}

                  {/* Import */}
                  {/* <div className="my-import d-flex align-items-center justify-content-center gap-2">
                  <ImportIc />
                  <div style={{ paddingBottom: "4px" }}>Import</div>
                </div> */}
                  <div className="cursor-pointer d-flex align-items-center justify-content-center gap-2 px-3" style={{ height: "40px" }}>
                    {checkPermission("create_permission") && (
                      <div
                        className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                        style={{
                          height: "40px",
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #3469E7",
                          color: "#3469E7",
                        }}
                        onClick={handleDownloadTemplate}
                      >
                        <DownloadIc />
                        <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                          Template
                        </div>
                      </div>
                    )}

                    {checkPermission("create_permission") && (
                      <div
                        className="cursor-pointer add-new d-flex align-items-center justify-content-center gap-2 px-3"
                        onClick={() => setShowExcelUploadModal(true)}
                        style={{
                          height: "40px",
                          backgroundColor: "#FFFFFF",
                          border: "1px solid #3469E7",
                          color: "#3469E7",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <ImportIc />
                        </div>
                        <div className="fs-12 fw-600" style={{ lineHeight: "16px" }}>
                          Import
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex flex-wrap justify-content-start gap-2">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          //   minWidth: "186px",
                          backgroundColor: "white",
                        }}
                        title={selectedSortby.label}
                      >
                        {/* Left: "Sort by" label */}
                        <span className="fs-12 fw-400 textGrey">Sort by :</span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">{selectedSortby.label}</span>

                          {/* <span className="dropdown-toggle-arrow textPurple">
                            <DownArrow />
                          </span> */}
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent parent onClick from firing
                              setSelectedSortBy(option); // Execute your selection logic
                            }}
                            active={selectedSortby === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <SearchableDropdown apiUrl={`${apiUrl}customer/autosuggestion`} placeholder="Customer" value={customerSelect} onSelect={handleSelectCustomer} handleClear={handleClearCustomer} />
                  </div>
                  <div>
                    <SearchableDropdown apiUrl={`${apiUrl}get_locations`} placeholder="Location" value={locationSelect} onSelect={handleSelectLocation} handleClear={handleClearLocation} />
                  </div>
                  <div>
                    <SearchableDropdown apiUrl={`${apiUrl}trips/status`} placeholder="Status" value={statusSelect} onSelect={handleSelectStatus} handleClear={handleClearStatus} />
                  </div>
                  {/* <div>
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "6px 12px",
                          backgroundColor: "white",
                        }}
                      >
                        
                        <span className="fs-12 fw-400 textGrey">Status :</span>

                       
                        <span className="d-flex align-items-center px-1">
                          <span className="dropdown-text">
                            {statusSelect?.label || "Select"}
                          </span>

                          
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "8px",
                          border: "1px solid #EBEBEB",
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {stageOption.map((option) => (
                          <Dropdown.Item
                            className="fs-14 fw-500 textcolor"
                            key={option.value}
                            onClick={() => setStatusSelect(option)}
                            active={statusSelect?.value === option.value}
                          >
                            {option.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div> */}
                  {/* <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_parts`}
                      placeholder="Product"
                      value={productSelect}
                      onSelect={handleSelectProduct}
                      handleClear={handleClearProduct}
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_pr_stages`}
                      placeholder="Status"
                      value={statusSelect}
                      onSelect={handleSelectStatus}
                      handleClear={handleClearStatus}
                    />
                  </div> */}
                  <div
                    className="d-flex align-items-center px-1"
                    style={{
                      borderRadius: "8px",
                      height: "32px",
                      border: "1px solid #EBEBEB",

                      backgroundColor: "white",
                    }}
                  >
                    <span className="fs-12 fw-400 textGrey">Date :</span>
                    <span className="dropdown-text1 ps-1 pb-1">
                      {" "}
                      <DateRangePicker onChange={handleDateChange} startDate={startDate} endDate={endDate} />
                    </span>
                  </div>{" "}
                  {/* <div
                  className="d-flex align-items-center px-1"
                  style={{
                    borderRadius: "12px",
                    border: "1px solid #EBEBEB",

                    backgroundColor: "white",
                  }}
                >
                  <span className="fs-12 fw-400 textGrey">Date :</span>
                  <span className="dropdown-text textPurple">
                    {" "}
                    <DateRangePicker onChange={handleDateChange} />
                  </span>
                </div>
                 */}
                  <div
                    className="cursor-pointer ms-1 fs-12 fw-400 textGrey text-decoration-underline d-flex align-items-center justify-content-center"
                    style={{ height: "30px" }}
                    onClick={() => {
                      setCustomerSelect(null);
                      setLocationSelect(null);
                      setStatusSelect(null);
                      setStartDateSave(null);
                      setEndDateSave(null);
                      setStartDate(null);
                      setEndDate(null);
                    }}
                  >
                    Reset Filters
                  </div>
                </div>

                <div
                  className="rounded-3 toggleBg d-flex mt-2"
                  style={{
                    width: "80px",
                    height: "32px",
                    backgroundColor: "#FFFFFF", // toggle background
                    padding: "4px",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                    border: "1px solid #EBEBEB",
                  }}
                >
                  <div
                    onClick={() => setActive("list")}
                    className={`d-flex align-items-center justify-content-center rounded-3  ${active === "list" ? "bg-primary1" : ""}`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "list" ? <ListView style={iconStyle} /> : <SelectList style={iconStyle} />}
                  </div>

                  <div
                    onClick={() => setActive("grid")}
                    className={`d-flex align-items-center justify-content-center rounded-3 ${active === "grid" ? "bg-primary1" : ""}`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "grid" ? <SelectGrid style={iconStyle} /> : <EmailView style={iconStyle} />}
                  </div>
                </div>
              </div>
            </div>
            {active === "list" && (
              <div className="w-100 trip-table-wrapper bg-white rounded-4 w-100 ">
                <div
                  style={{
                    display: "flex",
                    flex: "7",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    paddingTop: "16px",
                    height: "40px",
                    backgroundColor: "#FFFFFF",
                    border: "1px solid #e5e5e5",
                  }}
                  className="head3 w-100 justify-content-start align-items-center"
                >
                  {/* <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleChange}
                                style={{ marginRight: "8px", marginBottom: "14px" }}
                              /> */}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={tripIdIcon} alt="tripid" className="me-1" /> TRIP ID
                  </p>
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={timeIcon} alt="time" className="me-1" /> STARTS ON
                  </p>
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor  text-start table-header-p">
                    <img src={timeIcon} alt="time" className="me-1" />
                    ENDS ON
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={truckIcon} alt="truck" className="me-1" /> VEHICLE NAME
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={truckIcon} alt="truck" className="me-1" /> VEHICLE ID
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={addressIcon} alt="address" className="me-1" /> START ADDRESS
                  </p>{" "}
                  <p style={{ flex: "1" }} className="fs-13 fw-700 textcolor text-start table-header-p">
                    <img src={addressIcon} alt="address" className="me-1" /> END ADDRESS
                  </p>{" "}
                </div>
                <div>
                  {(tripsList ?? []).map((item, index) => (
                    <div
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",

                        backgroundColor: hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        borderLeft: "1px solid #D4DDE7",
                        borderRight: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                        position: "relative", // ⭐ REQUIRED FIX
                        overflow: "hidden", // prevent overlap
                      }}
                      onClick={() => {
                        if (checkPermission("view_permission")) {
                          navigate("/trips/view", {
                            state: { id: item.id },
                          });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      {" "}
                      {/* <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={handleChange}
                                    style={{ marginRight: "8px", marginBottom: "0px" }}
                                  /> */}
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.trip_id}
                      >
                        {item.trip_id ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.trip_startdate}
                      >
                        {item.trip_startdate ?? "---"}
                      </p>
                      <div
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                        title={item.trip_enddate}
                      >
                        {" "}
                        {item.trip_enddate ?? "---"}
                      </div>
                      <div
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                        title={item.vehicle_name}
                      >
                        {" "}
                        {item.vehicle_name ?? "---"}
                      </div>{" "}
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.vin}
                      >
                        {item.vin ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.start_address}
                      >
                        {item.start_address ?? "---"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor text-start table-row-p"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.location}
                      >
                        {item.location ?? "---"}
                      </p>
                      {hoveredIndex === index && (
                        <div
                          style={{
                            position: "absolute",
                            // top: "50%",
                            right: "35px",
                            // transform: "translate(-50%, -50%)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            {checkPermission("edit_permission") && item.trip_status === "Created" && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/trips/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <img src={editIcon} alt="edit" />{" "}
                              </div>
                            )}
                            <span style={{ marginLeft: "16px" }}></span>
                            {checkPermission("delete_permission") && item.trip_status === "Created" && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <img src={deleteIcon} alt="edit" />
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {active === "grid" &&
              tripsList.map((stop, index) => (
                <div
                  key={index}
                  className="bg-white rounded-4  d-flex flex-wrap align-items-center justify-content-between   business-card w-100 p-3 mb-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("view_permission")) {
                      navigate("/trips/view", {
                        state: { id: stop.id },
                      });
                    }
                  }}
                >
                  <div className="col-3 d-flex" style={{ borderRight: "1px solid #EBEBEB" }}>
                    <div className="profile-wrapper" style={{ background: "#F4F4F4" }}>
                      <img key={index} src={tripIcon} alt="trip" className="profile-img" />
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-start gap-1 ps-3">
                      <div className="textFontColor fs-16 fw-600 ">{stop.trip_id ?? "-"}</div>
                      {stop.license_plate !== null && stop.license_plate !== "" && (
                        <div className="d-flex gap-2  align-items-center">
                          <img src={truckIcon} alt="license_plate" /> <span className="text-gray fs-12 fw-500">{stop.license_plate ?? ""}</span>
                          {" - "}
                          <span className="text-gray fs-12 fw-500">{stop.vehicle_name ?? ""}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-3 ps-3 d-flex flex-column align-items-start justify-content-start pe-1" style={{ borderRight: "1px solid #EBEBEB" }}>
                    <div className="d-flex flex-column flex-grow-1 align-items-start ">
                      <div className="fs-12 fw-600 cardTextGrey">
                        STARTS ON : <span className="fs-14 fw-400 textcolor">{stop.trip_startdate ?? ""}</span>
                      </div>
                      <div className="fs-12 fw-600 cardTextGrey mt-1">
                        ENDS ON : <span className="fs-14 fw-400 textcolor">{stop.trip_enddate ?? ""}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-4 ps-3 d-flex flex-column align-items-start justify-content-start pe-1" style={{ borderRight: "1px solid #EBEBEB" }}>
                    <div className="d-flex flex-column flex-grow-1 align-items-start ">
                      <div className="d-flex align-items-center justify-content-start  fs-12 fw-600 cardTextGrey">
                        <span style={{ width: "50px" }}> FROM : </span>
                        <span className="ms-2 fs-14 fw-400 textcolor two-line-ellipsis">{stop.start_address ?? ""}</span>
                      </div>
                      <div className="d-flex align-items-center justify-content-start fs-12 fw-600 cardTextGrey mt-1">
                        <span style={{ width: "50px" }}> TO : </span>
                        <span className="ms-2 fs-14 fw-400 textcolor two-line-ellipsis">{stop.location ?? ""}</span>
                      </div>
                    </div>
                  </div>

                  <div className="col-2  d-flex flex-row  align-items-end justify-content-end gap-2 ps-3">
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          bsPrefix="custom-toggle"
                          variant="light"
                          id="dropdown-sort"
                          className="d-flex align-items-center justify-content-between bg-ECF2FF rounded-3"
                          style={{
                            padding: "6px 12px",
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span className=" fs-11 fw-700 text-3469E7">{stop.trip_status ?? "-"}</span>

                            {/* <span className="dropdown-toggle-arrow"></span> */}
                          </span>
                        </Dropdown.Toggle>

                        {/* <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "8px",
                            border: "1px solid #EBEBEB",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          }}
                        >
                          {stageListOption.map((option) => (
                            <Dropdown.Item
                              className="fs-14 fw-500 textcolor"
                              key={option}
                              onClick={() =>
                                updateStage(stop.id, option.value)
                              }
                              // active={selected === option}
                            >
                              {option.label}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu> */}
                      </Dropdown>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      {(((checkPermission("edit_permission") || checkPermission("delete_permission")) && stop.trip_status === "Created") || stop.trip_status !== "Trip end") && (
                        <Dropdown>
                          <Dropdown.Toggle
                            bsPrefix="custom-toggle"
                            variant="light"
                            id="dropdown-sort"
                            className="d-flex align-items-center justify-content-between  rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <img src={moreIcon} alt="more" />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "8px",
                              border: "1px solid #EBEBEB",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            {stop.trip_status !== "Trip end" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  getMilestoneDetails(stop.id);
                                }}
                              >
                                Update Milestone
                              </Dropdown.Item>
                            )}

                            {stop.trip_status !== "Trip end" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setAllocationTripId(stop.id);
                                  setShowDriverAllocationModal(true);
                                }}
                              >
                                Allocate Driver
                              </Dropdown.Item>
                            )}
                            {checkPermission("edit_permission") && stop.trip_status === "Created" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/trips/create", {
                                    state: { id: stop.id },
                                  });
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission("delete_permission") && stop.trip_status === "Created" && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(stop.id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-end">
        <Toast className="d-inline-block m-1" bg={snackbarStatus === true ? "success" : "danger"} show={showSnackbar} onClose={handleSnackbarClose} delay={3000} autohide>
          <Toast.Body style={{ color: "#ffffff" }}>{snackbarMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};
